// Pythagorean theorem, solve for c
const getDistanceBetweenTwoPoints = (a, b) =>
  (((a.x - b.x) ** 2) + ((a.y - b.y) ** 2)) ** .5;

export default getDistanceBetweenTwoPoints;